import React, { forwardRef } from 'react';
import { Carousel } from '@design-system/carousel';

import { adultosPromoData } from './adultosPromoData';
import { IAdultosPromoCarousel } from './models';
import PromoSlide from './PromoSlide';

const AdultosPromoCarousel = forwardRef<HTMLDivElement, IAdultosPromoCarousel>(
  ({ variant = 'tempra' }, ref) => {
    const data = adultosPromoData[variant] || adultosPromoData.tempra;
    const slides = data?.slides || [];

    if (!slides.length) return null;

    if (slides.length === 1) {
      return <PromoSlide {...slides[0]} />;
    }

    return (
      <Carousel
        ref={ref}
        className="hkx-promo-carousel"
        variant="single"
        gap={0}
        centerInsufficientSlides={false}
        buttonPrev={{ 'aria-label': 'Anterior' }}
        buttonNext={{ 'aria-label': 'Siguiente' }}
        ariaLivePlaceholder={(activeIndex, totalCount) => `${activeIndex} de ${totalCount}`}
        items={slides.map((slide) => ({ children: <PromoSlide {...slide} /> }))}
      />
    );
  }
);

AdultosPromoCarousel.displayName = 'AdultosPromoCarousel';

export default AdultosPromoCarousel;
